module.exports = __webpack_public_path__ + "img/old-logo.1265ec3e.png";